import Flipper from './flipper.js';

export default new Flipper();
